var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d2-container',{attrs:{"type":"card"}},[_c('template',{slot:"header"},[_vm._v("Header")]),_c('d2-demo-article'),_c('template',{slot:"footer"},[_vm._v("Footer")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }